var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpaceId = function SvgSpaceId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.081 24.37c0-1.53 1.242-2.77 2.774-2.77h1.11a2.772 2.772 0 0 1 2.773 2.77v1.107c0 1.53-1.242 2.77-2.774 2.77h-1.11a2.772 2.772 0 0 1-2.773-2.77v-1.108Zm2.774-12.74a2.771 2.771 0 0 0-2.774 2.77v1.108a2.771 2.771 0 0 0 2.774 2.769h1.11a2.772 2.772 0 0 0 2.773-2.77V14.4c0-1.53-1.242-2.77-2.774-2.77h-1.11Z",
    fill: "#1EEFA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.095 0C4.968 0 0 4.96 0 11.077v13.846C0 31.041 4.968 36 11.095 36h13.87c6.127 0 11.095-4.96 11.095-11.077V11.077C36.06 4.959 31.091 0 24.963 0H11.095Zm13.87 4.43h-13.87c-3.676 0-6.657 2.976-6.657 6.647v13.846c0 3.67 2.98 6.646 6.657 6.646h13.87c3.676 0 6.656-2.975 6.656-6.646V11.077c0-3.67-2.98-6.646-6.657-6.646Z",
    fill: "#1EEFA4"
  })));
};
export default SvgSpaceId;